/**
 * Bitbucket Authentication Service
 * Handles authentication flow for Bitbucket integration
 * Connects the account through provider-token-service
 * All authentication goes through BFF
 */

import providerLinkService from './ProviderLinkService';

class BitbucketAuthService {
  /**
   * Check whether the user has connected this provider
   * @returns {Promise<boolean>}
   */
  async isAuthenticated() {
    try {
      const status = await providerLinkService.checkLinkStatus('bitbucket');
      return status.linked;
    } catch (error) {
      console.error('❌ Bitbucket authentication check error:', error);
      return false;
    }
  }

  /**
   * Disconnect the provider and clear local credentials
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await providerLinkService.unlinkProvider('bitbucket');
      console.log('✅ Bitbucket logout successful');
    } catch (error) {
      console.error('❌ Bitbucket logout error:', error);
      throw error;
    }
  }
}

const BitbucketAuth = new BitbucketAuthService();
export default BitbucketAuth;
